module.exports = __webpack_public_path__ + "img/thumbnail_CollaredPeccary_f_normal.451bacab.png";